import { render, staticRenderFns } from "./com-join-step.vue?vue&type=template&id=5edb41fc&"
import script from "./com-join-step.vue?vue&type=script&lang=js&"
export * from "./com-join-step.vue?vue&type=script&lang=js&"
import style0 from "./com-join-step.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports